import { render, staticRenderFns } from "./PostsNav.vue?vue&type=template&id=d98cae20&scoped=true"
import script from "./PostsNav.vue?vue&type=script&lang=js"
export * from "./PostsNav.vue?vue&type=script&lang=js"
import style0 from "./PostsNav.vue?vue&type=style&index=0&id=d98cae20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98cae20",
  null
  
)

export default component.exports